import { OrgCard } from "./org_card";

const LINE_COLOR = "#d0daea";
const LINE_THICKNESS = 2;

export function OrgChartDesktop({ ceo, directReports, subReports, izzanIndex }) {
  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
        paddingBottom: 24,
        WebkitOverflowScrolling: "touch",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: 950,
          padding: "0 24px",
          gap: 0,
        }}
      >
        {/* CEO */}
        {ceo && <OrgCard anggota={ceo} size="lg" highlight />}

        {/* Garis vertikal dari CEO */}
        <div
          style={{ width: LINE_THICKNESS, height: 40, background: LINE_COLOR }}
        />

        {/* Level 1: Direct reports */}
        <div style={{ position: "relative", width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 0,
              alignItems: "flex-start",
              position: "relative",
            }}
          >
            {directReports.map((person, idx) => {
              const isFirst = idx === 0;
              const isLast = idx === directReports.length - 1;
              const isIzzan = idx === izzanIndex;
              const hasSubReports = isIzzan && subReports.length > 0;

              return (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: hasSubReports ? 2.5 : 1,
                    minWidth: hasSubReports ? 340 : 150,
                    position: "relative",
                  }}
                >
                  {/* Horizontal + vertical connector */}
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 40,
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                    }}
                  >
                    {!isFirst && (
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          width: "50%",
                          height: LINE_THICKNESS,
                          background: LINE_COLOR,
                        }}
                      />
                    )}
                    {!isLast && (
                      <div
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          width: "50%",
                          height: LINE_THICKNESS,
                          background: LINE_COLOR,
                        }}
                      />
                    )}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: LINE_THICKNESS,
                        height: "100%",
                        background: LINE_COLOR,
                      }}
                    />
                  </div>

                  <OrgCard anggota={person} size="md" highlight={isIzzan} />

                  {hasSubReports && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          width: LINE_THICKNESS,
                          height: 32,
                          background: LINE_COLOR,
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: 0,
                          alignItems: "flex-start",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        {subReports.map((sub, si) => {
                          const isSubFirst = si === 0;
                          const isSubLast = si === subReports.length - 1;
                          return (
                            <div
                              key={si}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                flex: 1,
                              }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  height: 32,
                                }}
                              >
                                {!isSubFirst && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      top: 0,
                                      width: "50%",
                                      height: LINE_THICKNESS,
                                      background: LINE_COLOR,
                                    }}
                                  />
                                )}
                                {!isSubLast && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: 0,
                                      top: 0,
                                      width: "50%",
                                      height: LINE_THICKNESS,
                                      background: LINE_COLOR,
                                    }}
                                  />
                                )}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: LINE_THICKNESS,
                                    height: "100%",
                                    background: LINE_COLOR,
                                  }}
                                />
                              </div>
                              <OrgCard anggota={sub} size="sm" />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
